import { HQ_LOCATION_PARSER } from './../../utils/location/location-parser';
import { DATE_YMD, FROM_UTC } from '../../utils/date/date-parser';
import { BID_STATUS_UUID } from '../../bid';
import { IS_NOT_NULL_OR_UNDEFINED, TO_DOLLARS } from './../../utils/commonUtils';
import { CarrierBidTable } from '../views';
import { CarrierBidResponse } from './../dtos/carrier-bid-response';
import { FULL_NAME } from '../../utils';

export const CARRIER_BID_TABLE = (
	carrierBids: Array<CarrierBidResponse> = []
): Array<CarrierBidTable> => {
	let results: Array<CarrierBidTable> = [];
	try {
		if (carrierBids.length > 0) {
			carrierBids.map((carrierBid) => {
				let row = {} as CarrierBidTable;
				row.bidId = carrierBid.bidId;
				row.referenceNumber = carrierBid.referenceNumber;
				row.origin = HQ_LOCATION_PARSER(carrierBid.originCity, carrierBid.originState);
				row.destination = HQ_LOCATION_PARSER(
					carrierBid.destinationCity,
					carrierBid.destinationState
				);
				row.equipment = carrierBid.equipment;
				row.pickupDate = DATE_YMD(FROM_UTC(carrierBid.pickupDate));
				row.deliveryDate = DATE_YMD(FROM_UTC(carrierBid.deliveryDate));
				row.bidStatus = BID_STATUS_UUID[carrierBid.bidStatus];
				row.offeredPrice = TO_DOLLARS(carrierBid.offeredPrice);
				row.bidAmount = TO_DOLLARS(carrierBid.bidAmount);
				const customer = carrierBid.customer;
				if (IS_NOT_NULL_OR_UNDEFINED(customer)) {
					row.customerName = FULL_NAME(customer.firstName, customer.lastName);
					row.customerEmail = customer.email;
					row.customerPhone = customer.phoneNumber;
					row.brokerBusinessName = customer.businessName;
				}
				row.bidHistoryList = carrierBid.bidHistoryList;
				row.outOfNetwork = carrierBid.outOfNetwork;
				results.push(row);
			});
		}
	} catch (error) {
		console.log('CARRIER_BID_TABLE error: ', error);
	}
	return results;
};
